import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Zap, Menu, X, MessageCircle } from "lucide-react";
import { NAV, waLink } from "../../data";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 flex justify-center px-3 pt-3 sm:pt-5"
      data-testid="site-header"
    >
      <motion.nav
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className={`flex w-full max-w-6xl items-center justify-between rounded-2xl px-4 py-3 transition-[background,box-shadow,border] duration-300 ${
          scrolled ? "glass shadow-2xl" : "bg-transparent border border-transparent"
        }`}
      >
        <a
          href="#home"
          className="flex items-center gap-2"
          data-testid="logo-link"
        >
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-[#FFC400]">
            <Zap className="h-5 w-5 text-[#0B1F3A]" strokeWidth={2.6} />
          </span>
          <span className="font-display text-lg font-extrabold tracking-tight text-white">
            ELETTRIK<span className="text-[#FFC400]">PRO</span>
          </span>
        </a>

        <div className="hidden items-center gap-8 lg:flex">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              className="text-sm font-medium text-white/70 transition-colors duration-200 hover:text-[#FFC400]"
              data-testid={`nav-${n.href.replace("#", "")}`}
            >
              {n.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            className="hidden items-center gap-2 rounded-full bg-[#FFC400] px-5 py-2.5 text-sm font-bold text-[#0B1F3A] transition-transform duration-200 hover:scale-[1.04] sm:flex"
          >
            <MessageCircle className="h-4 w-4" strokeWidth={2.5} /> WhatsApp
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="grid h-10 w-10 place-items-center rounded-lg text-white lg:hidden"
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            className="glass absolute top-[76px] left-3 right-3 rounded-2xl p-4 lg:hidden"
            data-testid="mobile-menu"
          >
            <div className="flex flex-col gap-1">
              {NAV.map((n) => (
                <a
                  key={n.href}
                  href={n.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-4 py-3 text-base font-medium text-white/80 transition-colors hover:bg-white/5 hover:text-[#FFC400]"
                  data-testid={`mobile-nav-${n.href.replace("#", "")}`}
                >
                  {n.label}
                </a>
              ))}
              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-[#FFC400] px-5 py-3 font-bold text-[#0B1F3A]"
                data-testid="mobile-whatsapp-btn"
              >
                <MessageCircle className="h-5 w-5" /> Scrivi su WhatsApp
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
